export const FLAG_EMOJI_TO_CODE = {
  '🇬🇧': 'gb',
  '🇦🇪': 'ae',
  '🇺🇸': 'us',
  '🇷🇺': 'ru',
  '🇩🇪': 'de',
  '🇫🇷': 'fr',
  '🇪🇺': 'eu',
};

export const normalizeFlagCode = (value) => {
  if (!value) {
    return null;
  }

  if (FLAG_EMOJI_TO_CODE[value]) {
    return FLAG_EMOJI_TO_CODE[value];
  }

  const normalized = String(value).trim().toLowerCase();
  return /^[a-z]{2}$/.test(normalized) ? normalized : null;
};
